import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CompoApp } from '../CompoApp';
import { Observable } from 'rxjs';
import { UrlBuilder } from '../../models/frontend_entities/UrlBuilder';
import Constants from '../../Constants';
import { AppData } from '../AppData';

@Injectable({
  providedIn: 'root'
})
export class ChecklistTemplateVersionReleasedClassesRequestService {

  private http = inject(HttpClient);
  private app = inject(CompoApp);
  private data = this.app.data;

  public saveSelection(checklistTemplateId: string, versionId: string, selectedClassIds: string[]): Observable<void> {
    const url = new UrlBuilder(Constants.URLS.checklistTemplates.releasedClasses)
      .pathParam('{templateId}', checklistTemplateId)
      .pathParam('{versionId}', versionId)
      .param('accessMode', this.data.getAccessMode())
      .build();

    return this.http.post<void>(url, selectedClassIds);
  }
}
